import { format } from "date-fns";

export function getFullDate(date) {
  return format(date, "dd/MM/yyyy");
}

export function getMonthYearDate(date) {
  return format(date, "MM/yyyy");
}

export function getIsoWeekDate(date) {
  return format(date, "yyyy-'W'II");
}

export function getDateAndTime(date) {
  return format(date, "dd/MM/yyyy - 'Time:' HH:mm");
}

export function getDateTime(date) {
  return format(date, "dd/MM/yyyy - HH:mm");
}

export function getLongDate(date) {
  return format(date, "do MMMM yyyy");
}

export function getReadDate(date) {
  return format(date, "d MMMM yyyy");
}

export function getDayMonth(date) {
  return format(date, "dd MMMM");
}
